import { render, staticRenderFns } from "./EventPostbackReport.vue?vue&type=template&id=da1d8ff0&scoped=true&"
import script from "./EventPostbackReport.vue?vue&type=script&lang=js&"
export * from "./EventPostbackReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d8ff0",
  null
  
)

export default component.exports